module.exports = __webpack_public_path__ + "img/1540148796.f7217586.jpg";